import { u as o } from "../styled-components.browser.esm-3eb04950.js";
import { Col as e, Row as r } from "antd";
const l = o(e)`
    margin-left: 5px;
`, p = o(r)`
  display: flex;
  justify-content: ${({ justify: t }) => t ?? "space-between"};
  ${({ $gap: t }) => t ? `gap: ${t}px;` : ""}
  height: 100%;
  width: 100%;
  align-items: center;

    ${({ $clickable: t }) => t ? `
    color: var(--primary);
  
    &:hover {
      opacity: 0.7;
      color: var(--primary);
    }
  ` : ""}
`, n = o.div`
  ${({ $color: t }) => `background-color: ${t};`}
  height: 32px;
  width: 32px;
`, c = o(n)`
    border-radius: 3px;
    height: 24px;
    width: 24px;
`, s = o.div`
    margin-top: 10px;
    margin-bottom: 10px;
`, g = o.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    font-size: 12px;
`, x = o.div`
    margin-right: 30px;
    margin-left: 30px;
    display: flex;
    flex-direction: column;
    gap: 10px;
`, h = o.span`
    display: flex;
    align-items: center;
    gap: 8px;
    line-height: 20px;
    font-weight: 600;
    margin-bottom: 8px;
`, b = o.div`
    display: flex;
    justify-content: end;
    position: absolute;
    right: 0;
    width: 75px;
    background: rgb(246, 246, 248);
    background: linear-gradient(90deg, rgba(246, 246, 248, 0) 0%, rgba(246, 246, 248, 0.48503151260504207) 35%, rgba(246, 246, 248, 1) 100%);
    padding-right: 5px;
`, u = o.div`
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    height: 100%;
`, f = o.div`
    font-size: 24px;
    font-weight: 600 !important;
    border-bottom: 1px solid var(--border-color-base);
    margin-bottom: 8px;
`, i = o.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden; // used to color widget header after link animation
  background-color: white;
  border-radius: var(--big-border-radius);
  box-shadow: 0px 8px 12px rgba(27, 27, 29, 0.02);

  -webkit-touch-callout: none; /* iOS Safari */
  /* Non-prefixed version, currently supported by Chrome and Opera */
`, m = o(i)`
    ${({ $color: t }) => `background-color: ${t};`}
    height: calc(100% - 60px);
    max-height: calc(100% - 60px);
    width: 100%;
    padding: 0;
    min-height: 0;
    overflow-y: auto;
`, v = o(i)`
  border-radius: 0 var(--big-border-radius) var(--big-border-radius) var(--big-border-radius);
`;
export {
  i as CardEffectDiv,
  v as CardEffectDivWithoutTopLeftRadius,
  m as ColoredCard,
  n as ColoredElement,
  c as ColoredElementWithRadius,
  l as ContentCol,
  b as DeleteContainer,
  u as ErrorBoundaryResultContainer,
  p as FlexMetricOptionRow,
  f as PageTitle,
  h as TooltipAlias,
  g as TooltipContainer,
  x as TooltipContentElement,
  s as TooltipText
};
//# sourceMappingURL=SharedStyledComponent.js.map
